<app-d-form-group (control)="aaDetailFormControl = $event" [formArray]= "aaDetailForm"></app-d-form-group>
